import { motion } from "framer-motion";
import { TIERS } from "@/lib/tiers";
import TierCard from "@/components/sections/accessgates/TierCard";
import GridBackground from "@/components/primitives/GridBackground";

export default function AccessGates() {
    return (
        <section
            id="access-gates"
            data-testid="access-gates-section"
            className="relative bg-tca-panel overflow-hidden"
        >
            <GridBackground />
            {/* Twin glow accents */}
            <div
                aria-hidden="true"
                className="pointer-events-none absolute -top-32 -left-32 w-[520px] h-[520px] rounded-full"
                style={{
                    background: "radial-gradient(circle, rgba(0,224,232,0.10), transparent 70%)",
                    filter: "blur(48px)",
                }}
            />
            <div
                aria-hidden="true"
                className="pointer-events-none absolute -bottom-40 -right-40 w-[600px] h-[600px] rounded-full"
                style={{
                    background: "radial-gradient(circle, rgba(255,107,255,0.06), transparent 70%)",
                    filter: "blur(56px)",
                }}
            />

            <div className="relative z-10 max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 py-28 sm:py-40">
                {/* Header */}
                <div className="text-center max-w-3xl mx-auto">
                    <motion.div
                        initial={{ opacity: 0, y: 8 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6 }}
                        className="font-mono-tight text-[10px] sm:text-[11px] uppercase tracking-[0.36em] text-tca-cyan/85 mb-5"
                        data-testid="access-eyebrow"
                    >
                        // Access Gates
                    </motion.div>
                    <motion.h2
                        initial={{ opacity: 0, y: 16, filter: "blur(6px)" }}
                        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                        data-testid="access-headline"
                        className="font-display text-[44px] leading-[1.04] sm:text-[64px] sm:leading-[1.0] lg:text-[80px] lg:leading-[0.98] tracking-[-0.025em] text-tca-ink"
                    >
                        Choose Your Path.
                    </motion.h2>
                    <motion.p
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        className="font-display italic neon-cyan text-xl sm:text-2xl mt-3"
                    >
                        Each tier opens a deeper layer of the intelligence ecosystem.
                    </motion.p>
                </div>

                {/* 4-card grid */}
                <div
                    data-testid="tier-grid"
                    className="
                        mt-16 sm:mt-20 grid
                        grid-cols-1 sm:grid-cols-2 lg:grid-cols-4
                        gap-5 sm:gap-6
                    "
                >
                    {TIERS.map((tier, i) => (
                        <TierCard key={tier.id} tier={tier} index={i} />
                    ))}
                </div>

                {/* Coming-soon anchor for tier CTAs */}
                <div
                    id="access-coming-soon"
                    data-testid="access-coming-soon"
                    className="mt-20 sm:mt-24 text-center"
                >
                    <div className="font-mono-tight text-[11px] uppercase tracking-[0.32em] text-tca-ink-muted/70">
                        // Stripe checkout activates Phase 2
                    </div>
                </div>
            </div>
        </section>
    );
}
